/* COVA quick view: loads the product into the drawer with the Section Rendering API, then handles options, slider and quantity */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    var CV = window.CV;
    var drawer = null;

    function init(root) {
      var content = root.querySelector('[data-cv-qv-content]');
      var slider = content.querySelector('[data-cv-qv-slider]');
      if (slider && window.Swiper) {
        var count = slider.querySelectorAll('.swiper-slide').length;
        var opts = { slidesPerView: count > 1 ? 1.5 : 1, centeredSlides: count > 1, spaceBetween: 4, grabCursor: true };
        new window.Swiper(slider, opts);
      }
      var jsonEl = content.querySelector('[data-cv-qv-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var form = content.querySelector('form');
      var idInput = form && form.querySelector('[data-cv-variant-id]');
      var priceBox = content.querySelector('[data-cv-qv-price]');
      var stock = content.querySelector('[data-cv-qv-stock]');
      var add = content.querySelector('[data-cv-qv-add]');
      function selected() {
        var vals = [];
        content.querySelectorAll('[data-cv-option]').forEach(function (fs) {
          var r = fs.querySelector('input:checked');
          vals.push(r ? r.value : null);
        });
        return vals;
      }
      function update() {
        var vals = selected();
        var match = (product.variants || []).find(function (v) {
          return vals.every(function (val, i) { return val === null || (v.options ? v.options[i] : v['option' + (i + 1)]) === val; });
        });
        if (!match) {
          if (add) { add.disabled = true; add.textContent = add.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceBox) {
          var html = '<span class="cv-qv__now">' + CV.money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) html += '<s class="cv-qv__was">' + CV.money(match.compare_at_price) + '</s>';
          priceBox.innerHTML = html;
        }
        if (stock) {
          stock.classList.toggle('is-in', !!match.available);
          stock.classList.toggle('is-out', !match.available);
          stock.lastChild.textContent = match.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
        }
        if (add) { add.disabled = !match.available; add.textContent = match.available ? add.getAttribute('data-add') : add.getAttribute('data-sold'); }
        // slide to the variant photo
        if (slider && slider.swiper && match.featured_image) {
          var slides = Array.prototype.slice.call(slider.querySelectorAll('.swiper-slide'));
          var at = slides.findIndex(function (s) { return String(s.getAttribute('data-image-id')) === String(match.featured_image.id); });
          if (at > -1) slider.swiper.slideTo(at);
        }
      }
      content.addEventListener('change', function (e) { if (e.target.closest('[data-cv-option]')) update(); });
    }

    function open(url) {
      drawer = drawer || document.getElementById('cv-quick-view');
      if (!drawer) { window.location.href = url; return; }
      var id = drawer.getAttribute('data-section-id');
      var content = drawer.querySelector('[data-cv-qv-content]');
      content.innerHTML = '<div class="cv-qv__loading">&hellip;</div>';
      CV.openDrawer(drawer);
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'sections=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
        var doc = new DOMParser().parseFromString(data[id] || '', 'text/html');
        var fresh = doc.querySelector('[data-cv-qv-content]');
        if (!fresh || !fresh.children.length) { window.location.href = url; return; }
        content.innerHTML = fresh.innerHTML;
        init(drawer);
      }).catch(function () { window.location.href = url; });
    }
    CV.quickView = { open: open };

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cv-quickview]');
      if (!b) return;
      e.preventDefault();
      open(b.getAttribute('data-cv-quickview'));
    });
    document.addEventListener('cv:quickview:open', function (e) { if (e.detail && e.detail.url) open(e.detail.url); });
  });
})();
